export default "__VITE_ASSET__DB3pgbTw__"